module.exports = __webpack_public_path__ + "static/media/familia3.cc7f3e42.jpg";